import main from "../../assets/img/covenant.png"

export default function Covenant() {
    return (
        <main className="portfolioDetail">
            <h1>Covenant Group - Web Design / Development</h1>
            <img src={main} alt="project information" loading="lazy" />
        </main>
    );
  }